import script from "./NewsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewsPage.vue?vue&type=script&lang=ts&setup=true"

import "./NewsPage.vue?vue&type=style&index=0&id=d22ad160&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d22ad160"]])

export default __exports__